import React, { useState, useRef } from "react";
import queryString from "query-string";
import { Form, Progress, Alert } from "reactstrap";

import { WithLocalize } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';

import logo from "./img/logo.png"

const LoginForm = ({ api, location, translate, TurnstileComponent, turnstileSuccess, setTurnstileSuccess }) => {
  const [onLogin, setOnLogin] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);
  parameters.idp = "zaaz";

  const onSubmit = async (ev) => {
    ev.preventDefault();

    setOnLogin(true);
    setError({
      open: false,
      message: "",
    });

    api.userPassLogin(
      {
        username,
        password,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false);
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const translatedError = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage");

        if (translatedError) {
          message = translatedError;
        } else if (error.details) {
          message = error.details;
        }

        setOnLogin(false);
        setError({ open: true, message });
      });
  };

  return (
    <>
      <Form onSubmit={onSubmit} className="zaaz-login">
        <div className="zaaz-wrapper">
          <div className="zaaz-form-group">
            <div className="zaaz-form-content">
              <div>
                <img src={logo} alt="zaaz" />
              </div>
              <div className="zaaz-title">
                <p>{translate("title")}</p>
              </div>
              <div className="zaaz-form-container zaaz-form-container-login">
                <input
                  disabled={onLogin}
                  placeholder={translate("PlaceholderUserName")}
                  required={true}
                  tabIndex={1}
                  type="text"
                  autoCorrect="off"
                  autoCapitalize="none"
                  name="login"
                  id="login-zaaz"
                  onChange={e => setUsername(e.target.value)}
                />
              </div>
              <div className="zaaz-form-container">
                <input
                  required={true}
                  disabled={onLogin}
                  placeholder={translate("PlaceholderPassword")}
                  tabIndex={1}
                  type="password"
                  autoCorrect="off"
                  autoCapitalize="none"
                  id="password-zaaz"
                  name="login"
                  onChange={e => setPassword(e.target.value)}
                />
              </div>
              <div className="zaaz-button">
                {!onLogin ? (
                  <button type="submit" disabled={!turnstileSuccess}>
                    <span className="zaaz-enter-text">
                      {translate("ButtonEnter")}
                    </span>
                  </button>
                ) : (
                  <Progress animated color="danger" value={100} />
                )}
              </div>
              <div className="zaaz-links">
                <p className='forgotPass-zaaz'>
                  <a href="https://recover.zaaztelecom.com.br/" target="_blank" rel="noopener noreferrer">
                    {translate('ForgotPassword')}
                  </a>
                </p>
                <p className='helpMe-zaaz'>
                  <a href="https://api.whatsapp.com/send/?phone=5508004949999&text&type=phone_number&app_absent=0/" target="_blank" rel="noopener noreferrer">
                    {translate('helpMe')}
                  </a>
                </p>
              </div>
              {error.open && (
                <div className="messages-container">
                  <Alert
                    color="danger"
                    id="error-message"
                    isOpen={true}
                    toggle={() => setError({ open: false })}
                  >
                    {error.message}
                  </Alert>
                </div>
              )}
              <div className="turnstile-container">
                <TurnstileComponent setTurnstileSuccess={setTurnstileSuccess} />
              </div>
            </div>
          </div>
        </div>
      </Form>
    </>
  );
};

export default WithCaptcha(WithLocalize(LoginForm), { useInsideForm: true, style: { marginTop: '2rem' } });
